function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useLayoutEffect as e } from "@radix-ui/react-use-layout-effect";
import { useComposedRefs as n } from "@radix-ui/react-compose-refs";
import * as t from "react";
export var Presence = function Presence(u) {
  var o = u.present,
      i = u.children,
      s = function (n) {
    var _t$useState = t.useState(),
        _t$useState2 = _slicedToArray(_t$useState, 2),
        u = _t$useState2[0],
        o = _t$useState2[1],
        i = t.useRef({}),
        s = t.useRef(n),
        c = t.useRef("none"),
        a = n ? "mounted" : "unmounted",
        _ref = function (e, n) {
      return t.useReducer(function (e, t) {
        var r = n[e][t];
        return null != r ? r : e;
      }, e);
    }(a, {
      mounted: {
        UNMOUNT: "unmounted",
        ANIMATION_OUT: "unmountSuspended"
      },
      unmountSuspended: {
        MOUNT: "mounted",
        ANIMATION_END: "unmounted"
      },
      unmounted: {
        MOUNT: "mounted"
      }
    }),
        _ref2 = _slicedToArray(_ref, 2),
        d = _ref2[0],
        m = _ref2[1];

    return t.useEffect(function () {
      var e = r(i.current);
      c.current = "mounted" === d ? e : "none";
    }, [d]), e(function () {
      var e = i.current,
          t = s.current;

      if (t !== n) {
        var _u = c.current,
            _o = r(e);

        if (n) m("MOUNT");else if ("none" === _o || "none" === (null == e ? void 0 : e.display)) m("UNMOUNT");else {
          var _e2 = _u !== _o;

          m(t && _e2 ? "ANIMATION_OUT" : "UNMOUNT");
        }
        s.current = n;
      }
    }, [n, m]), e(function () {
      if (u) {
        var _e3 = function _e3(e) {
          var n = r(i.current).includes(e.animationName);
          e.target === u && n && m("ANIMATION_END");
        },
            _n2 = function _n2(e) {
          e.target === u && (c.current = r(i.current));
        };

        return u.addEventListener("animationstart", _n2), u.addEventListener("animationcancel", _e3), u.addEventListener("animationend", _e3), function () {
          u.removeEventListener("animationstart", _n2), u.removeEventListener("animationcancel", _e3), u.removeEventListener("animationend", _e3);
        };
      }

      m("ANIMATION_END");
    }, [u, m]), {
      isPresent: ["mounted", "unmountSuspended"].includes(d),
      ref: t.useCallback(function (e) {
        e && (i.current = getComputedStyle(e)), o(e);
      }, [])
    };
  }(o),
      c = "function" == typeof i ? i({
    present: s.isPresent
  }) : t.Children.only(i),
      a = n(s.ref, c.ref);

  return "function" == typeof i || s.isPresent ? /*#__PURE__*/t.cloneElement(c, {
    ref: a
  }) : null;
};

function r(e) {
  return (null == e ? void 0 : e.animationName) || "none";
}

Presence.displayName = "Presence";